import { pgTable } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const Transactions = pgTable('transactions', (t) => ({
  transactionId: t.text('transaction_id'),
  recurringVendorId: t.text('recurring_vendor_id'), // nullable
  vendorName: t.text('vendor_name'),   // nullable
  totalAmount: t.real('total_amount'), // nullable
  transactionDate: t.text('transaction_date'), // varchar, nullable
  organizationId: t.text('organization_id'), // nullable
  lineId: t.text('line_id'),
  detailType: t.text('detail_type'),
  description: t.text('description'),
  subCategory: t.text('sub_category'),
  accountValue: t.text('account_value'),
  taxCode: t.text('tax_code'),
  billableStatus: t.text('billable_status'),
  source: t.text('source'),
  category: t.text('category'),
  currency: t.text('currency')
}))
// Types
export type Transaction = typeof Transactions.$inferSelect
export type TransactionInsert = typeof Transactions.$inferInsert
// Zod Schemas
export const insertTransactionSchema = createInsertSchema(Transactions, {
  totalAmount: z.coerce.number().optional(),
  transactionDate: z.string().optional()
})
export const selectTransactionSchema = createSelectSchema(Transactions)